export default __webpack_public_path__ + "static/media/newFooter.d87153cb.png";